<template>
  <div>
    <div class="ti d-flex">
      <div class="d-flex-left">
        <erp-tree @node-click="nodeClick"></erp-tree>
      </div>
      <div class="d-flex-right" style="">
        <!--        <el-select v-model="company_code">
                  <el-option
                    v-for="item in company_list"
                    :key="item.id"
                    :label="item.company_name"
                    :value="item.id">
                  </el-option>
                </el-select>
                <el-button @click="flow(1)">发起流程</el-button>-->
        <div style="width: 99%;">
          <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}" @selection-change="handleSelectionChange">
            <el-descriptions-item label="房产信息">
              <el-input v-model="select.house_name" size="mini" placeholder="房产信息" disabled></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="支付时间">
              <el-date-picker v-model="select.pay_start" type="date" value-format="yyyy-MM-dd" size="mini"  style="width: 47%;" placeholder="开始日期"></el-date-picker>
              <span style="margin-left: 1px;margin-right: 1px;">至</span>
              <el-date-picker v-model="select.pay_end" type="date" value-format="yyyy-MM-dd" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="订单类型">
              <el-select v-model="select.order_type">
                <el-option
                  v-for="item in order_type_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="经办人">
              <el-input v-model="select.xsc_Account" size="mini" placeholder="账号" ></el-input>
            </el-descriptions-item>
            <!--            <el-descriptions-item label="差额">
                          <el-select v-model="select.cash_type">
                            <el-option
                              v-for="item in cash_type_list"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </el-descriptions-item>-->
          </el-descriptions>
        </div>
        <div style="margin-top: 10px;">

          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="日记账" name="first">
              <el-button @click="change(1)">查询</el-button>
              <el-button @click="bankFlow(1)">转存</el-button>
              <!-- 显示查询订单的总金额 -->
              <div class="total-amount" style="margin-top: 10px;padding: 10px; background-color: #f5f5f5; border: 1px solid #ddd; margin-bottom: 10px;">
                <span>选中金额：<span style="color: red;">{{money_val}}</span>元</span>
                <span style="margin-left: 15px;">总金费：<span style="color: red;">{{trade_amount}}</span>元</span>
                <!--            <div style="margin-top: 5px;">
                              <span v-for="item in xsc_summary" :key="item.account" style="margin-right: 15px;">
                                {{item.account}}：<span style="color: blue;">{{item.charge_paid}}</span>元
                              </span>
                            </div>-->
              </div>

              <el-table ref="multipleTable" height="65vh" :data="tableData" border style="width: 99%" v-loading="table_loading"
                        @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" />
                <el-table-column prop="ids" label="ids" width="80" show-overflow-tooltip></el-table-column>
                <!--            <el-table-column prop="order_id" label="账单ID" width="80"></el-table-column>-->
                <el-table-column type="index" label="序号" width="80"></el-table-column>
                <el-table-column prop="account_date" label="记账日期" width="100"></el-table-column>
                <el-table-column prop="pindex_name" label="项目名称" width="100"></el-table-column>
                <el-table-column label="收款" align="center">
                  <el-table-column prop="all_charge_paid" label="金额" width="80"></el-table-column>
                  <el-table-column prop="h_name_date" label="房产" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="xsc_bill_no" label="票据号码" width="150"></el-table-column>
                  <el-table-column prop="operator_date" label="日期" width="150"></el-table-column>
                  <el-table-column prop="xsc_Account" label="经办人" width="100"></el-table-column>
                </el-table-column>
                <el-table-column label="转存" align="center">
                  <el-table-column prop="all_save_cash" label="金额" width="100">
                    <template #default="scope">
                      <el-link type="primary" v-show="Number(scope.row.all_save_cash) > 0" @click="openDetailDialog(scope.row.ids)">
                        {{ scope.row.all_save_cash }}
                      </el-link>
                      <span v-show="Number(scope.row.all_save_cash) === 0">{{ scope.row.all_save_cash }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="xsc_Account" label="认领人" width="100"></el-table-column>
                  <el-table-column prop="all_diff_cash" label="差额" width="100"></el-table-column>
                </el-table-column>
                <!--            <el-table-column prop="charge_name" label="收费项目" width="180"></el-table-column>-->
                <!--            <el-table-column label="计费周期" width="180">
                              <template slot-scope="scope">
                                {{scope.row.startDate}}-{{scope.row.endDate}}
                              </template>
                            </el-table-column>-->
                <!--            <el-table-column prop="customer_name" label="客户名称" width="100"></el-table-column>-->
                <!--            <el-table-column prop="state_name" label="状态" width="60"></el-table-column>-->
                <!--            -->
                <!--            <el-table-column prop="remark" label="备注" width="200"></el-table-column>-->
              </el-table>
              <!--          <el-pagination
                          style="float: right; margin-top: 10px; margin-right: 20px"
                          background
                          @size-change="handleSizeChange"
                          @current-change="handlePageChange"
                          :page-sizes="[10,20,50,100,200,500]"
                          :small="true"
                          layout="sizes,prev, pager, next"
                          :page-size="pageData.pageSize"
                          :total="pageData.total"
                          :current-page.sync="pageData.page"
                        >
                        </el-pagination>-->

            </el-tab-pane>
            <el-tab-pane label="已转存" name="second">
              <!--已转存开始-->
              <el-button @click="change1(1)">查询</el-button>
              <!-- 显示查询已转存订单的总金额 -->
              <div class="total-amount" style="margin-top: 10px;padding: 10px; background-color: #f5f5f5; border: 1px solid #ddd; margin-bottom: 10px;">
                <span>选中金额：<span style="color: red;">{{money1_val}}</span>元</span>
                <span style="margin-left: 15px;">总金费：<span style="color: red;">{{trade_amount1}}</span>元</span>
              </div>
              <el-table ref="multipleTable" height="65vh" :data="tableData1" border style="margin-top:10px;width: 99%" v-loading="table_loading1"
                        @selection-change="handleSelectionChange1">
                <el-table-column type="selection" width="55" />
                <el-table-column prop="id" label="id" width="80"></el-table-column>
                <el-table-column label="操作" align="center" width="180">
                  <template #default="scope">
                    <el-link type="primary" v-show="Number(scope.row.incurred_amount) > 0" @click="flow(scope.row.id)">
                      发起流程
                    </el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="state_name" label="状态" width="100"></el-table-column>
                <el-table-column prop="transaction_date" label="存款日期" width="150"></el-table-column>
                <el-table-column prop="opposite_name" label="存款人" width="150"></el-table-column>
                <el-table-column prop="transaction_serial_number" label="银行流水号" width="150"></el-table-column>
                <el-table-column prop="incurred_amount" label="金额" width="180"></el-table-column>
<!--                <el-table-column prop="xsc_bill_no" label="票据号" width="180"></el-table-column>
                <el-table-column prop="xsc_Account" label="收款人" width="100"></el-table-column>
                <el-table-column prop="money" label="转存金额" width="100"></el-table-column>-->
                <el-table-column prop="detail" label="明细" align="left">
                  <template #default="scope">
                    <el-table :data="scope.row.child" border style="margin-top:10px;width: 99%" v-loading="table_loading1"
                              >
                      <el-table-column prop="xsc_bill_no" label="票据号" width="180"></el-table-column>
                      <el-table-column prop="xsc_Account" label="收款人" width="100"></el-table-column>
                      <el-table-column prop="money" label="转存金额" width="100"></el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination background layout="prev, pager, next"
                             @current-change="handleBankPageChange1"
                             :current-page.sync="bank1.page"
                             :page-count="bank1.page_count"
                             :page-size="bank1.page_size">
              </el-pagination>
              <!--已转存结束-->
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>

    <!--    <el-dialog title="确认退款吗 ？" :visible="refund.visible" @close="refund.visible = false" v-loading="table_loading">
          <el-form>
            <el-form-item label="退款金额">
              <span >{{refund.money}}</span>
            </el-form-item>
            <el-form-item label="退款原因/备注">
              <el-input type="textarea" placeholder="请输入内容" v-model="refund.remark"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="sendRefund" type="primary">确定</el-button>
              <el-button @click="refund.visible = false">取消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>-->

    <el-dialog title="现金转存" :visible="bank.visible" @close="bank.visible = false" :loading="prove_uploading">
      <el-table :data="xsc_summary" border style="width: 100%" show-summary :summary-method="getSummary">
        <el-table-column prop="account" label="经办人" align="center"></el-table-column>
        <el-table-column label="转存金额" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.save_cash" size="small" @input="validateMoney(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="现金" align="center">
          <el-table-column prop="original_cash" label="账户金额" align="center"></el-table-column>
          <el-table-column label="余额" align="center">
            <template slot-scope="scope">{{ (Number(scope.row.original_cash) - Number(scope.row.save_cash || 0)).toFixed(2) }}</template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px">
        <!--        <el-descriptions :column="4" border size="mini" style="margin-top: 10px;">
                  <el-descriptions-item label="上次附件">
                    <el-upload
                      class="bank-upload"
                      :action="uploadUrl"
                      list-type="picture-card"
                      :file-list="bank.imgList"
                      :limit="1"
                      :before-upload="bankBeforeUpload"
                      :on-success="bankUploadSuccess"
                      :on-remove="bankRemoveImg"
                      :on-exceed="bankExceed">
                      <i class="el-icon-plus"></i>
                    </el-upload>

                  </el-descriptions-item>
                </el-descriptions>-->

        <el-descriptions :column="4" border size="mini" style="margin-top: 10px;">
          <el-descriptions-item label="上传附件">
            <el-upload
              class="upload-demo"
              :http-request="handleProveUpload"
              action=""
              :show-file-list="true"
              :limit="1"
              :file-list="prove_file_list"
              :on-preview="taskView"
              list-type="text">
              <!--            <el-button size="small" type="primary" :loading="prove_uploading">点击上传</el-button>-->
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">支持jpg/png/pdf格式，大小不超过10M</div>
            </el-upload>
          </el-descriptions-item>
        </el-descriptions>
        <div style="text-align: right; margin-top: 15px;">
          <el-button type="primary" @click="openCbsFlowDialog">确认</el-button>
        </div>
        <!--        <div style="text-align: right; margin-top: 15px;">
                  <el-button type="primary" @click="submitBank">确认</el-button>
                </div>-->
      </div>
    </el-dialog>

    <el-dialog title="明细" :visible="detail.visible" @close="detail.visible = false" width="70%" v-loading="detail_loading">
      <el-table :data="detail.tableData" border style="width: 100%">
        <el-table-column prop="account_date" label="记账日期" align="center"></el-table-column>
        <el-table-column prop="pindex_name" label="项目名称" align="center"></el-table-column>
        <el-table-column prop="charge_paid" label="金额" align="center"></el-table-column>
        <el-table-column prop="bill_number" label="票据号" align="center"></el-table-column>
        <el-table-column prop="xsc_Account" label="经办人" align="center"></el-table-column>
        <el-table-column prop="money" label="转存金额" align="center"></el-table-column>
        <el-table-column prop="transaction_serial_number" label="流水号" align="center"></el-table-column>
        <el-table-column prop="create_time" label="日期" align="center"></el-table-column>
        <el-table-column prop="admin_name" label="认领人" align="center"></el-table-column>
        <el-table-column prop="digest" label="摘要" align="center"></el-table-column>
        <el-table-column prop="url" label="附件" align="center">
          <template #default="scope">
            <el-link type="primary" @click="taskView({'URL':scope.row.url,'Name':'附件'})">
              查看
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="差额" align="center">
          <template slot-scope="scope">{{ (Number(scope.row.charge_paid) - Number(scope.row.money || 0)).toFixed(2) }}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <ViewFile ref="ViewFile" />

    <!-- CBS流水选择器组件 -->
    <cbs-flow-selector-cash
      :visible.sync="cbs_flow_dialog_visible"
      :pindex-id="this.select.pindex_id"
      :pay-amount="totalSaveCash"
      @confirm="handleFlowConfirm"
      @close="cbs_flow_dialog_visible = false"
    />

    <!-- CBS流水详情组件 -->
    <cbs-flow-detail
      :visible.sync="flow_detail_visible"
      :flow-data="current_flow_row"
      @close="flow_detail_visible = false"
    >
    </cbs-flow-detail>

    <!--    <el-dialog title="补录订单" :visible="bind.visible" @close="bind.visible = false">
          <el-form>
            <el-form-item label="参考号">
              <el-input v-model="bind.trade_no" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="订单类型">
              <el-radio-group v-model="bind.order_type">
                <el-radio label="order" value="order">应收款</el-radio>
                <el-radio label="temporary" value="temporary">临时收费</el-radio>
                <el-radio label="advance" value="advance">预收款</el-radio>
                <el-radio label="deposit" value="deposit">押金</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="收据号">
              <el-input v-model="bind.bill_no"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="sendBindOrder">确定</el-button>
              <el-button @click="bind.visible = false">取消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>-->
  </div>
</template>

<script>
import ObjectStorage from '../../../common/ObjectStorage';
import CbsFlowSelectorCash from "./component/CbsFlowSelectorCash.vue";
import CbsFlowDetail from "./order/CbsFlowDetail.vue";
import ViewFile from "../Common/ViewFile.vue";

export default {
  name: 'CashOrder',
  provide(){
    return{
      __ORDER__:null
    }
  },
  data () {
    return {
      activeName:'first',
      company_code : '',
      company_list : {},
      pageData:{
        id:0,
        pid:0,
        list:[],
        total:0,
        page:1,
        pageSize:10,
      },
      pageData1:{
        id:0,
        pid:0,
        list:[],
        total:0,
        page:1,
        pageSize:10,
      },
      selectList:[],
      select:{
        pay_start : '',
        pay_end : '',
        house_id : 0 ,
        order_type : 'order' ,
        cash_type : '0' ,
        house_name : '',
        pindex_id : 0,
        trade_status : '',
        bind_status : '',
      },
      order_type_list: [{
        value: 'order',
        label: '账单'
      }, {
        value: 'advance',
        label: '预收款'
      }, {
        value: 'deposit',
        label: '押金'
      }],
      cash_type_list: [{
        value: '0',
        label: '全部'
      }, {
        value: '1',
        label: '有差额'
      }, {
        value: '2',
        label: '有差额'
      }],
      money_val:0,
      money1_val:0,
      // 按经办人汇总的收款金额 [{account, all_charge_paid}]
      xsc_summary: [],
      xsc_summary1: [],
      // CBS流水相关
      has_cbs_config : false,
      cbs_flow_dialog_visible : false,
      selected_flows : [],
      cbs_flow_list : [],
      flow_filter : {
        timeRange : [],
        account_no : '',
        bank_type : ''
      },
      cbs_pagination : {
        page : 1,
        pageSize : 20,
        total : 0
      },
      cbs_config_checking : false,
      isConfirmButtonDisabled : false,
      bankTypeOptions : [], // 银行类型选项列表
      flow_detail_visible : false, // 流水详情对话框
      current_flow_row : null, // 当前查看的流水行

      // 图片上传
      prove_uploading: false,
      prove_form: {
        remark: '',
        file_path: ''
      },
      prove_file_list: [],
      prove_current_row: null,
      prove_bucket_name: 'gdza',

      uploadUrl: '',
      pid:'',
      tableData: [],
      tableData1: [],
      table_loading :false,
      table_loading1 :false,
      // 订单总金额
      trade_amount : 0,
      // 已转存
      trade_amount1 : 0,

      detail_loading :false,
      detail : {
        visible : false ,
        tableData : [] ,
        pageData : {
          id:0,
          pid:0,
          list:[],
          total:0,
          page:1,
          pageSize:10,
        },
        trade_amount:0
      },

      refund:{
        visible : false,
        money : 0 ,
        remark : '' ,
        id : 0,
      },

      bank : {
        visible : false ,
        pos_no : '',
        pos_list : [],
        // 默认当天时间
        time: [],
        order_list : [],
        order_loading : false,
        page_count : 0,
        page : 1,
        page_size : 20,
        // 上传凭证图片
        imgList : [],
        img : '',
      },
      bank1 : {
        visible : false ,
        pos_no : '',
        pos_list : [],
        // 默认当天时间
        time: [],
        order_list : [],
        order_loading : false,
        page_count : 0,
        page : 1,
        page_size : 20,
        // 上传凭证图片
        imgList : [],
        img : '',
      },

      bind : {
        visible : false,
        order_type : 1 ,
        bill_no : '',
        trade_no : '',
        merchant_no : '',
        trade_time : '',
        online_id : 0,
      }
    }
  },
  //界面没出来前加载
  created() {
    const d = new Date();
    const today = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    this.select.pay_start = today;
    this.select.pay_end = today;

    d.setDate(d.getDate() - 1);
    const yesterday = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    this.select.pay_start = yesterday;
    this.select.pay_start = '2026-08-01';
    this.select.pay_end = yesterday;
    this.change();
  },
  // 加载数据
  mounted(){
    this.__ORDER__=this;
    // 页面打开时加载公司列表
    this.getCompanyList();
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    },
    totalSaveCash(){
      return this.xsc_summary.reduce((sum, item) => {
        return sum + Number(item.save_cash || 0);
      }, 0);
    }
  },
  //事件
  methods: {
    handleClose() {

    },
    //点击树
    nodeClick(data){
      if(data.tree.length > 0){
        // 最后一个元素
        let treeData = data.tree[data.tree.length - 1];
        if(treeData.type === 'project'){
          this.select.pindex_id = treeData.pindex_id;
          this.select.house_id = 0;
          this.select.house_name = treeData.name;
        }else{
          this.select.house_id = treeData.house_id ;
          this.select.house_name = treeData.ancestor_name;
        }
      }
    },
    //搜索账单
    change(e){
      if(this.select.pindex_id == 0){
        this.$Message.error('请选择项目');
        return;
      }
      this.table_loading = true;
      let params = Object.assign({} , this.select);
      params.page = this.pageData.page;
      params.limit = this.pageData.pageSize;

      console.log(params);
      this.$myhttp.post('admin/orderCash/index',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        this.table_loading = false;
        // console.log(backdata.data.data)
        if(backdata.data.code == 200){
          this.tableData = backdata.data.data.list;
          this.pageData.total = backdata.data.data.count;
          this.trade_amount = backdata.data.data.total;
        }else{
          this.$Message.error(backdata.data.msg);
        }
      } , err=>{
        this.table_loding = false;
        this.loading_dade = 1;
        //ERP.hideLoading()
        this.$Message.error('请求异常!');
      });
    },
    //搜索账单
    change1(e){
      if(this.select.pindex_id == 0){
        this.$Message.error('请选择项目');
        return;
      }
      this.table_loading1 = true;
      let params = Object.assign({} , this.select);
      params.page = this.pageData1.page;
      params.limit = this.pageData1.pageSize;

      console.log(params);
      this.$myhttp.post('admin/orderCash/transferred',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        this.table_loading1 = false;
        // console.log(backdata.data.data)
        if(backdata.data.code == 200){
          this.tableData1 = backdata.data.data.list;
          this.pageData1.total = backdata.data.data.count;
          this.trade_amount1 = backdata.data.data.total;
        }else{
          this.$Message.error(backdata.data.msg);
        }
      } , err=>{
        this.table_loding1 = false;
        this.loading_dade = 1;
        //ERP.hideLoading()
        this.$Message.error('请求异常!');
      });
    },
    handleBankPageChange1(val){
      this.bank1.page = val;
      this.change1();
    },
    getCompanyList(){
      this.$myhttp.post('admin/orderCash/getCompanyList',{},{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        if(backdata.data.code == 200){
          this.company_list = backdata.data.data.list;
        }else{
          this.$Message.error(backdata.data.msg);
        }
      } , err=>{
        this.$Message.error('请求异常!');
      });
    },
    //跳流程
    flow(e){
      // if(this.company_code == ''){
      //   this.$Message.error('请选择分公司');
      //   return false;
      // }
      if(!e){
        this.$Message.error('流水参数不存在');
        return false;
      }
      /*if(this.orderData.length < 1){
        this.$Message.error('没有账单');
        return false;
      }*/
      this.$confirm('确定操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {'company_code': this.company_code, 'id': e}
        ERP.showLoading()
        this.$myhttp.post('admin/orderCash/adjustAdd', data, {
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata => { // 异步执行成功后
          ERP.hideLoading()
          if (backdata.data.code == 200) {
            this.$Message.success('操作成功!');
            const timestamp = Date.parse(new Date());
            let url = "https://crm.gdzawy.com:9000/#/flow/FlowView?sheet_id=415&master_id=347&timeValue="+timestamp+"&batch="+backdata.data.data;
            window.open(url, '_blank');
            this.change(this.page);
          } else {
            this.$Message.error(backdata.data.msg);
          }
        }, err => {
          ERP.hideLoading()
          this.$Message.error('请求异常!');
        });
      })
      // let number = this.orderData[0]['number'];
      // const timestamp = Date.parse(new Date());
      // let url = "/#/flow/FlowView?sheet_id=33&master_id=132&timeValue="+timestamp+"&batch="+number;
      // window.open(url, '_blank');
    },
    //查询该客户所有费项
    all(){
      this.select.all.type = 2;
      this.select.all.house = this.house.map(req=>{return req.id}).join(',');
      this.change(1);
    },

    //搜索框选中房产
    changes(e){
      this.select.name = '';
      this.user_type = 1;
      this.select.house = e;
      this.change(1);
    },
    //勾选账单
    handleSelectionChange(val) {
      this.order = val;
      let money = 0;
      this.order.map(req=>{
        money = Number(money) + Number(req.all_charge_paid);
      })
      this.money_val = money.toFixed(2);

      // 按经办人(xsc_Account)汇总 all_charge_paid、all_diff_cash 和 ids
      let summary = {};
      let diffSummary = {};
      let idsSummary = {};
      this.order.forEach(req=>{
        let account = req.xsc_Account || '未指定';
        summary[account] = (summary[account] || 0) + Number(req.all_charge_paid || 0);
        diffSummary[account] = (diffSummary[account] || 0) + Number(req.all_diff_cash || 0);
        idsSummary[account] = idsSummary[account] || [];
        idsSummary[account].push(req.ids);
      });
      this.xsc_summary = Object.keys(summary).map(account=>{
        return {
          account: account,
          // save_cash: summary[account].toFixed(2),
          save_cash: diffSummary[account].toFixed(2),
          original_cash: diffSummary[account].toFixed(2),// 读取 multipleTable 的 all_diff_cash 汇总
          diff_cash: diffSummary[account].toFixed(2),
          ids: idsSummary[account]
        };
      });
    },
    //勾选账单
    handleSelectionChange1(val) {
      this.order1 = val;
      let money = 0;
      this.order1.map(req=>{
        money = Number(money) + Number(req.money);
      })
      this.money1_val = money.toFixed(2);

      // 按经办人(xsc_Account)汇总 all_charge_paid、all_diff_cash 和 ids
      let summary = {};
      let diffSummary = {};
      let idsSummary = {};
      this.order1.forEach(req=>{
        let account = req.xsc_Account || '未指定';
        summary[account] = (summary[account] || 0) + Number(req.all_charge_paid || 0);
        diffSummary[account] = (diffSummary[account] || 0) + Number(req.all_diff_cash || 0);
        idsSummary[account] = idsSummary[account] || [];
        idsSummary[account].push(req.ids);
      });
      this.xsc_summary1 = Object.keys(summary).map(account=>{
        return {
          account: account,
          // save_cash: summary[account].toFixed(2),
          save_cash: diffSummary[account].toFixed(2),
          original_cash: diffSummary[account].toFixed(2),// 读取 multipleTable 的 all_diff_cash 汇总
          diff_cash: diffSummary[account].toFixed(2),
          ids: idsSummary[account]
        };
      });
    },
    //搜索选中
    handleSelect(item) {

    },
    // 转存金额数字校验：只允许数字和最多两位小数
    validateMoney(row) {
      let val = String(row.save_cash).replace(/[^\d.]/g, '');   // 去除非数字和小数点
      let dotIdx = val.indexOf('.');
      if (dotIdx !== -1) {
        val = val.slice(0, dotIdx + 1) + val.slice(dotIdx + 1).replace(/\./g, ''); // 去掉多余小数点
        val = val.slice(0, dotIdx + 3); // 最多两位小数
      }
      row.save_cash = val;
    },
    // 现金转存底部合计
    getSummary({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        let total = 0;
        data.forEach(row => {
          if (column.label === '转存金额') {
            total += Number(row.save_cash || 0);
          } else if (column.label === '账户金额') {
            total += Number(row.original_cash || 0);
          } else if (column.label === '余额') {
            total += (Number(row.original_cash || 0) - Number(row.save_cash || 0));
          }
        });
        sums[index] = column.label === '转存金额' || column.label === '账户金额' || column.label === '余额'
          ? total.toFixed(2) : '';
      });
      return sums;
    },
    // 移除当前聚焦元素焦点，避免 dialog 被 aria-hidden 时焦点残留报警告
    blurActive() {
      if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }
    },
    taskView(item=null,type=1) {
      const that=this;
      item = item?item:this.prove_file_list[0];
      console.log('item',item);
      if(item) {
        that.blurActive();
        let file_url=""
        if (item.base_url) {
          file_url=item.base_url+ item.URL
        }else {
          file_url=this.host_url+item.URL
        }
        console.log('file_url',file_url);
        let login_name = localStorage.getItem('login')
        let token = localStorage.getItem('token')
        if(type===1){
          that.$refs.ViewFile.show({
            width: '90vw',
            height:'80vh',
            title:item.Name,
            src:item.URL,
            bucket:'gdza',
            duration_time:86400*3,
            download(){
              // TODO 下载文件逻辑
              // window.open(`${that.host_url}/flow/FlowTaskFile/download?id=${item.id}&login_name=${login_name}&token=${token}`)
              __OSS__.setBucket('gdza').setKey(item.URL).download()
            }
          })
        }else {
          __OSS__.setBucket('gdza').setKey(item.URL).download()
        }
      }else{

        this.$message.warning('请先上传附件');
        return;
      }
    },
    // 打开CBS流水选择对话框
    openCbsFlowDialog() {
      if(!this.prove_file_list || this.prove_file_list.length < 1){
        this.$message.error('请先上传附件');
        return;
      }

      if(this.totalSaveCash <= 0){
        this.$message.error('转存金额不能为0');
        return;
      }

      const zeroItem = this.xsc_summary.find(item => Number(item.save_cash) <= 0);
      if(zeroItem){
        this.$message.error('经办人[' + (zeroItem.account || '未指定') + ']的转存金额不能为0');
        return;
      }

      this.blurActive();
      this.cbs_flow_dialog_visible = true;
    },
    // 处理流水确认
    handleFlowConfirm(flowId, flowData) {
      this.selected_flows = [flowId];
      this.cbs_flow_list = [flowData];
      this.isConfirmButtonDisabled = false;
      this.cbs_flow_dialog_visible = false;
      this.bank.visible = false;
      this.$message.success('已选择流水');
      const saveData = {
        'pindex_id': this.select.pindex_id,
        'order_type': this.select.order_type,
        'totalSaveCash' :this.totalSaveCash,
        'flowIds' :this.selected_flows,
        'xsc_summary' :this.xsc_summary,
        'flow' :this.cbs_flow_list,
        'prove_file_list' :this.prove_file_list,
        // 'order' :this.order,
      };
      this.saveCash(saveData);
      console.log('saveData',saveData);
    },
    saveCash(params){
      this.table_loading = true;
      this.$myhttp.post('admin/OrderCash/saveCash',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        this.table_loading = false;
        if(backdata.data.code == 200){
          this.$Message.success('操作成功');
          this.bank.visible = false;
          this.change();
        }else{
          this.$Message.error(backdata.data.msg);
        }
      } , err=>{
        this.table_loading = false;
        this.loading_dade = 1;
        this.$Message.error('请求异常!');
      });
    },
    // 打开CBS流水选择对话框
    openDetailDialog(e) {
      console.log('e',e);
      if (!e) {
        that.$message.error('没有明细id')
        return;
      }
      this.getDetailList(e);
      this.detail.visible = true;
    },
    // 获取明细列表
    // 获取明细列表
    getDetailList(e){
      if(this.select.pindex_id == 0){
        this.$Message.error('请选择项目');
        return;
      }
      const data = {
        'pindex_id': this.select.pindex_id,
        'order_type': this.select.order_type,
        'ids' :e,
      };

      this.$myhttp.post('admin/orderCash/getDetailList',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        this.detail_loading = false;
        // console.log(backdata.data.data)
        if(backdata.data.code == 200){
          this.detail.tableData = backdata.data.data.list;
          this.detail.pageData.total = backdata.data.data.count;
          this.detail.trade_amount = backdata.data.data.total;
        }else{
          this.$Message.error(backdata.data.msg);
        }
      } , err=>{
        this.detail_loading = false;
        //ERP.hideLoading()
        this.$Message.error('请求异常!');
      });
    },

    handlePageChange(e) {
      this.pageData.page = e;
      this.change(this.pageData.page);
    },
    handleSizeChange(val){
      this.pageData.pageSize = val;
      this.change(this.pageData.page);
    },
    // 检查是否可退款
    checkDelete(row){
      // 当月第一天时间戳
      let firstDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      let tradeTime = new Date(row.trade_time);
      return tradeTime >= firstDay;
    },
    sendRefund(){
      if(this.refund.remark == ''){
        this.$Message.error('请填写退款原因');
      }else{
        let params = { id : this.refund.id , remark : this.refund.remark }
        this.table_loading = true;
        this.$myhttp.post('admin/OrderOnlineRefund',params,{
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{
          this.table_loading = false;
          if(backdata.data.code == 200){
            this.$Message.success('退款成功');
            this.refund.visible = false;
            this.change();
          }else{
            this.$Message.error(backdata.data.msg);
          }
        } , err=>{
          this.table_loading = false;
          this.loading_dade = 1;
          this.$Message.error('请求异常!');
        });
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },

    // 存银行
    bankFlow(){
      if(this.select.pindex_id == 0){
        this.$Message.error('请选择项目');
        return;
      }
      console.log('this.$refs.multipleTable.selection.length',this.$refs.multipleTable.selection.length);
      if (this.$refs.multipleTable.selection.length == 0) {
        this.$Message.error('请勾选收款数据');
        return;
      }

      this.bank.visible = true;
      // 初始化上传地址（与项目其他上传一致）
      this.uploadUrl = this.$myhttp.defaults.baseURL + '/admin/posts';
      this.bank.imgList = [];
      this.bank.img = '';
      // this.getPosList();
    },
    // 使用ObjectStorage上传文件
    handleProveUpload(params) {
      this.prove_uploading = true;
      const file = params.file;

      // 校验文件类型
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isPDF = file.type === 'application/pdf';
      const isValidType = isJPG || isPNG || isPDF;

      if (!isValidType) {
        this.$message.error('只能上传jpg/png/pdf格式的文件!');
        this.prove_uploading = false;
        return;
      }

      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过10MB!');
        this.prove_uploading = false;
        return;
      }


      // 使用ObjectStorage上传
      ObjectStorage.getOssConfig(config => {
        const oss = new ObjectStorage(config);
        oss.setBucket(this.prove_bucket_name);

        const date = new Date();
        const date_path = date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate() + '/';
        const randomStr = Math.random().toString(36).slice(2, 10);
        const objectKey = date_path + randomStr + '_' + file.name;

        oss.upload(file, objectKey, (res) => {
          this.prove_uploading = false;
          if (res && res.path) {
            this.prove_form.file_path = res.path;
            this.prove_file_list = [{
              Name: file.name,
              URL: res.path
            }];
            this.$message.success('文件上传成功');
          } else {
            this.$message.error('文件上传失败');
            this.prove_file_list = [];
          }
        });
      });
    },
    // 上传前校验：只能上传一张图片
    bankBeforeUpload(file){
      if(this.bank.img){
        this.$Message.error('凭证只能上传一张图片');
        return false;
      }
    },
    // 上传成功
    bankUploadSuccess(response, file, fileList){
      this.bank.img = '/storage/' + response;
    },
    // 移除图片
    bankRemoveImg(file, fileList){
      this.bank.img = '';
    },
    // 超过一张
    bankExceed(files, fileList){
      this.$Message.error('凭证只能上传一张图片');
    },
    // 提交转存
    submitBank(){
      if(this.xsc_summary.length < 1){
        this.$Message.error('请先勾选收款数据');
        return;
      }
      if(!this.bank.img){
        this.$Message.error('请上传凭证图片');
        return;
      }
      let params = {
        pid : this.select.pindex_id,
        img : this.bank.img,
        list : JSON.stringify(this.xsc_summary)
      };
      this.$myhttp.post('admin/orderCashStore',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        if(backdata.data.code == 200){
          this.$Message.success('提交成功');
          this.bank.visible = false;
          this.change();
        }else{
          this.$Message.error(backdata.data.msg);
        }
      } , err=>{
        this.$Message.error('请求异常!');
      });
    },
    // 获取POS列表
    getPosList(){
      if(this.select.pindex_id == 0){
        this.$Message.error('请选择项目');
        return;
      }

      let url = 'admin/OrderOnline/getPosList?pid=' + this.select.pindex_id ;
      this.$myhttp.get(url ,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        if(backdata.data.code == 200){
          this.bank.pos_list = backdata.data.data;
          this.bank.order_list = [];
          this.bank.page = 1;
          this.bank.page_count = 0;
        }
      })
    },
  },
  watch:{

  },
  components: {
    ViewFile,
    CbsFlowSelectorCash,
    CbsFlowDetail,
    "erp-tree": () => import('../Common/erp-tree.vue'),
  },

}
</script>

<style>
.d-flex {
  display: flex;
}
.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
  width: 250px;

}
.d-flex-right {
  flex: 1;
  overflow-x:hidden;
}
.text2{
  color: rgb(250, 248, 248);
}
</style>

<style lang="scss" scoped>
.right-main {
  display: flex;
  // overflow: auto;//体内容的滚动条
  flex: 1;
  background: #fff;
}
.content{
  .header{

  }
  .header-where{
    margin-top: 5px;
  }
  .body{
    margin-top: 10px;

    .pagination-wrap{
      display: table;
      /* text-align: center; */
      margin: 20px auto;
    }
  }
}
// 缩小上传凭证图标
.bank-upload >>> .el-upload{
  width: 60px;
  height: 60px;
  line-height: 60px;
}
.bank-upload >>> .el-upload-dragger{
  width: 60px;
  height: 60px;
  line-height: 60px;
}
.bank-upload >>> .el-upload .el-icon-plus{
  font-size: 20px;
}
.bank-upload >>> .el-upload-list--picture-card .el-upload-list__item{
  width: 60px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/CashOrder.vue